<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-dialog v-model="dialog.snackbar"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="kominfoklaten" 
                :src="require('@/assets/icon/info_berhasil.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div>
                  Terima kasih, import data murni 
                  telah berhasil!
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Import Data
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7; height: calc(100vh - 250px); overflow-y: auto; overflow-x: hidden;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <ValidationProvider 
                        name="Unit"
                        rules="required"  
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>

                          Unit
                        </div>

                        <v-autocomplete
                          v-on:keyup.enter="save()"

                          filled
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Contoh. Badan Pengelolaan Keuangan"

                          hide-details

                          :items="unit"
                          item-text="title"
                          item-value="id"
                          :item-color="set_color"

                          v-model="form.unit_id"
                          :success="form.unit_id !== '' && valid"
                          :error-messages="errors"
                          required
                          class="mb-6"
                          style="border-radius: 10px; width: 50%;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
                            
                            <div v-if="form.unit_id !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>

                      <ValidationProvider 
                        name="Tahun" 
                        rules="required"
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          
                          Tahun
                        </div>

                        <v-select
                          v-on:keyup.enter="save()"

                          filled
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Contoh. 2023"

                          hide-details

                          :items="years"
                          :item-color="set_color"

                          v-model="form.year"
                          :success="valid"
                          :error-messages="errors"
                          required
                          class="mb-8"
                          style="border-radius: 10px; width: 20%;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                Tahun {{ errors[0] }}
                              </v-tooltip>
                            </div>
                            
                            <div v-if="form.year !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-select>
                      </ValidationProvider>

                      <div v-if="form.filename === ''">
                        <uploaddocument 
                          v-model="upload.doc">
                          <div 
                            slot="activator">
                            <v-card
                              flat
                              class="cursor-pointer"
                              style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                              <v-card-text
                                class="py-2">
                                <div v-if="!process.doc"
                                  class="d-flex align-center justify-center">
                                  <v-icon 
                                    size="28" 
                                    color="#b6b6b6">
                                    mdi-cloud-upload-outline
                                  </v-icon>

                                  <div
                                    class="black--text ml-2"
                                    style="opacity: 40%; font-weight: 500;">
                                    Upload File
                                  </div>
                                </div>

                                <div v-if="process.doc"
                                  class="text-center">
                                  <v-progress-circular
                                    indeterminate
                                    size="28"
                                    color="#b6b6b6">
                                  </v-progress-circular>
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>
                        </uploaddocument>
                      </div>

                      <div v-if="form.filename !== ''">
                        <v-card
                          flat
                          style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                          <v-icon
                            @click="form.filename = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>

                          <v-card-text
                            class="py-3 line-text-second">
                            <div
                              class="d-flex align-center">
                              <div style="width: 50px;">Nama</div> : {{ form.file_text }}
                            </div>

                            <div
                              class="d-flex align-center">
                              <div style="width: 50px;">Size</div> : {{ Math.round(form.file_size / 1000) }} Kb
                            </div>

                            <div
                              class="d-flex align-center">
                              <div style="width: 50px;">Mime</div> : {{ form.file_mime }}
                            </div>

                            <!-- <div
                              class="d-flex align-center">
                              <div style="width: 50px;">Url</div> : <a :href="form.filename" target="_blank" class="ml-1">{{ form.filename }}</a>
                            </div> -->
                          </v-card-text>
                        </v-card>
                      </div>
                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="2"
              class="py-0">
              <!-- :disabled="process.form || new Date() < new Date(dpa.perubahan_date) ? false : true" -->
              <v-btn
                @click="save()"
                :loading="process.form"
                block
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon size="20">mdi-checkbox-marked-circle-outline</v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  export default {
    data () {
      return {
        dialog: {
          snackbar: false
        },

        unit: [],

        form: {
          unit_id: '',
          unit_name: '',
          unit_asisten: '',
          year: new Date().getFullYear(),

          filename: '',
          file_text: '',
          file_size: '',
          file_mime: ''
        },

        upload: {
          doc: false
        },

        process: {
          load: false,
          form: false,

          doc: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploaddocument: () => import(/* webpackPrefetch: true */ '@/components/upload/document.vue')
    },
    watch: {
      'form.unit_id' (val) {
        let unit = this.unit.find(x => x.id === val)

        if (unit) {
          this.form.unit_name = unit.title
          this.form.unit_asisten = unit.asisten
        }
      },

      'upload.doc': {
        handler: function () {
          if (this.upload.doc) {
            this.process.doc = this.upload.doc.process

            if (!this.process.doc) {
              // CALLBACK FROM UPLOAD DOC
              
              this.form.filename = this.upload.doc.fileuri

              this.form.file_text = this.upload.doc.filename
              this.form.file_size = this.upload.doc.filesize
              this.form.file_mime = this.upload.doc.filemime

              this.process.doc = false

              // console.log(this.form.filename)
            }
          }
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      dpa () {
        return this.$store.state.dpa
      },
      mount () {
        return new Date(this.$store.state.dpa.perubahan_date).getMonth() + 1
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      years () {
        let max = new Date('10-01-2024').getFullYear()+6, min = max - 6, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    mounted () {
      this.fetchUnit()
    },
    methods: {
      async fetchUnit () {
        let params = {
          limit: 100000,
          year: new Date().getFullYear()
        }
        
        await get('admin/unit/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.unit = res.results.data
          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true
           let formData = new FormData()
                formData.append('filename', this.form.filename)
                formData.append('unit_id', this.form.unit_id)
                formData.append('unit_name', this.form.unit_name)
                formData.append('unit_asisten', this.form.unit_asisten)
                formData.append('year', this.form.year)


            this.process.form = true

            // this.$emit('input', {
            //   process: this.process.form
            // })

            fetch(`${process.env.VUE_APP_API_URL}admin/task/import`, {
              method: 'POST',
              body: formData,
              headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
            })
            .then(res => res.json())
            .then(response => {
              // console.log(response)
                 let res = response
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message

              this.form = {
                unit_id: '',
                unit_name: '',
                unit_asisten: '',
                year: new Date().getFullYear(),

                filename: '',
                file_text: '',
                file_size: '',
                file_mime: ''
              }
            } else {
              this.message.error = res.message
            }
            })
          

          // SAVE TO REST API
          // await post('admin/task/import', {
          //   data: this.form
          // })
          // .then(response => {
          //   let res = response.data
            
          //   this.process.form = false

          //   if (res.status === 200) {
          //     this.dialog.snackbar = true
          //     this.message.success = res.message

          //     this.form = {
          //       unit_id: '',
          //       unit_name: '',
          //       unit_asisten: '',
          //       year: new Date().getFullYear(),

          //       filename: '',
          //       file_text: '',
          //       file_size: '',
          //       file_mime: ''
          //     }
          //   } else {
          //     this.message.error = res.message
          //   }
          // })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>